import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/core/services/login/login.service';

@Component({
  selector: 'app-verifyuser',
  templateUrl: './verifyuser.component.html',
  styleUrls: ['./verifyuser.component.scss'],
})
export class VerifyuserComponent implements OnInit {
  constructor(private ls: LoginService, private router: Router) {}

  isdataLoaded = false;
  isPhoneNumberPresent = false;
  // header and button names
  headerText = 'Verify User';
  emailText = '<b>Email a code:</b> <br>';
  phoneNumberText = '<b>Text a code:</b> <br>';
  useremail = '';
  userPhone = '';
  inputTextAddPhoneNumber: string;
  subscriptions: Subscription[] = [];
  Code: string;

  ngOnInit(): void {
    this.subscriptions.push(
      this.ls.getUserEmailAndPhone().subscribe((res: any) => {
        this.useremail = res.email;
        this.userPhone = res.phoneNumber;
        if (this.userPhone === null || this.userPhone == '') {
          this.isPhoneNumberPresent = false;
          this.inputTextAddPhoneNumber = 'Add Phone Number';
        } else {
          this.isPhoneNumberPresent = true;
        }
        this.isdataLoaded = true;
      })
    );
  }

  async SendEmailCode() {
    const response = await this.ls.sendEmailCode(this.useremail);
    this.Code = response.Code;
    if (this.Code == null)
        this.verifyCode(true);
    else
      this.verifyByCode(true, this.Code);
    return true;
  }

  verifyByCode(isEmail: boolean, code: string) {
    this.router.navigate(['/verifycode'], {
      queryParams: { isEmail, code },
    });
  }

  async SendPhoneCode() {
    const response = await this.ls.sendPhoneCode(this.useremail);
    this.Code = response.Code;
    if (this.Code == null)
        this.verifyCode(false);
    else
      this.verifyByCode(false, this.Code);
    return true;
  }

  async AddPhoneNumber() {
    this.router.navigate(['/set-phonenumber']);
  }

  verifyCode(isEmail: boolean) {
    this.router.navigate(['/verifycode'], {
      queryParams: { isEmail },
    });
  }

  maskEmail(email: string): string {
    if (!email) {
      return '';
    }
    const parts = email.split('@');
    const username = parts[0];
    const maskedUsername = this.maskCharacters(username, 3);
    const maskedDomain = '*****.com';

    return `${maskedUsername}@${maskedDomain}`;
  }

  private maskCharacters(value: string, preserveCharacters: number): string {
    if (value.length <= preserveCharacters) {
      return value;
    }

    const maskedCharacters = '*'.repeat(value.length - preserveCharacters);
    const preservedSubstring = value.substring(0, preserveCharacters);

    return preservedSubstring + maskedCharacters;
  }

  maskPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) {
      return '';
    }

    const digitsOnly = phoneNumber.replace(/\D/g, ''); // Remove non-digit characters
    const maskedDigits = digitsOnly.substring(0, 6).replace(/\d/g, '*'); // Mask the first 6 digits
    const lastDigits = digitsOnly.substring(6); // Get the remaining digits

    return `(${maskedDigits})***-${lastDigits}`;
  }
}
